import arrowDown from '../assets/icons/arrow-down.png';
import arrowDownDark from '../assets/icons/arrow-down-dark.png';
import {useEffect, useState} from "react";
import {Link} from "react-router-dom";

function SimpleTable({data, onSortChange, total, isLight, head}: any) {
    const [sort, setSort] = useState('count');
    const [isSortDesc, setIsSortDesc] = useState(true);

    function onClickSort(changedSort: string) {
        if (sort === changedSort) {
            setIsSortDesc(prev => !prev);
        } else {
            const sortDesc = changedSort !== 'name';
            setIsSortDesc(sortDesc);
        }

        setSort(changedSort);
    }

    useEffect(() => {
        onSortChange(sort, isSortDesc ? 'desc' : 'asc');
    }, [sort, isSortDesc]);

    return (
        <table className="table-auto border-collapse w-full">
            <thead>
                <tr className="sticky top-0 bg-grey-900">
                    <th className={`pt-4 pb-2 px-2.5 font-body font-bold text-xs text-start w-2/3 ${isLight ? 'bg-grey-300' : 'border-b border-grey-700'}`}>
                        <button className="flex flex-nowrap items-center" onClick={() => onClickSort('name')}>
                            {head}
                            {sort === 'name' && <img src={arrowDown} className={`rotate-${isSortDesc ? '0' : '180'}`} height="15" width="15" alt="Sort"/>}
                        </button>
                    </th>
                    <th className={`pt-4 pb-2 px-2.5 font-body font-bold text-xs text-nowrap ${isLight ? 'bg-grey-300' : 'border-b border-grey-700'}`}>
                        <button className="flex flex-nowrap ml-auto items-center" onClick={() => onClickSort('count')}>
                            Jobb<wbr/>annonser
                            {sort === 'count' && <img src={isLight ? arrowDownDark : arrowDown} className={`rotate-${isSortDesc ? '0' : '180'}`} height="15" width="15" alt="Sort" />}
                        </button>
                    </th>
                    <th className="w-[8px]"></th>
                </tr>
            </thead>
            <tbody>
            {data.map((entry: any, index: number) => {
                const entryName = entry.name?.replaceAll(' ', ' <wbr>').replaceAll('/', '/<wbr>');
                if (!entry.name?.length) {return <></>}

                return <tr key={entry.name}>
                            <td className={`border-b py-3 px-2.5 font-body text-sm ${isLight ? 'border-grey-300' : 'border-grey-700'}`} lang="sv">
                                {entry.meta?._self
                                    ? <Link to={entry.meta._self} className="underline"  dangerouslySetInnerHTML={{__html: entryName}} />
                                    : <span dangerouslySetInnerHTML={{__html: entryName}} />
                                }
                            </td>
                            <td className={`border-b py-3 px-2.5 font-body text-sm text-end ${isLight ? 'border-grey-300' : 'border-grey-700'}`}>{entry.total.toLocaleString('sv')}</td>
                            <td></td>
                          </tr>;
            })}
            </tbody>
        </table>
    );
}

export default SimpleTable;